import { Link } from "react-router-dom";
import shoppingCartHelper from "../../helpers/shoppingCart.helper";
import useShoppingCart from "../../hooks/useShoppingCart.hook";

import "../../styles/components/shoppingCart/shoppingCartSummaryComponent.scss";

export const ShoppingCartSummaryComponent = () => {
  const { cartItems, removeItem, updateItemQuantity } = useShoppingCart();

  return (
    <div className="summaryAndCheckOutContainer">
      <div className="summaryDetailsComtainer">
        <span>סה"כ ללא מע"מ</span>
        <span>{shoppingCartHelper.calculateTotalPriceWithoutVat(cartItems, 18)} ₪</span>
      </div>
      <div className="summaryDetailsComtainer">
        <span>מע"מ 18%</span>
        <span>{shoppingCartHelper.calculateVatPrice(shoppingCartHelper.calculateTotalPrice(cartItems), 18)} ₪</span>
      </div>
      <div className="summaryDetailsComtainer">
        <span>סה"כ לתשלום</span>
        <span>{shoppingCartHelper.calculateTotalPrice(cartItems)} ₪</span>
      </div>

      <Link to={"checkout"} className={`primaryButton`}>
        בצע הזמנה
      </Link>
    </div>
  );
};

export default ShoppingCartSummaryComponent;
